import { render } from "./DashboardComparisonSales.vue?vue&type=template&id=8e1f869c&ts=true"
import script from "./DashboardComparisonSales.vue?vue&type=script&lang=ts"
export * from "./DashboardComparisonSales.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\DDrive\\DeveloperFolder\\VueJsApps\\byihusemanagt\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__